/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {OnboardSquareMerchantRequest} from '@cash-web/protos/squareup/cash/local/v1/seller/cash_app_local_seller_service.pb'
import {OnboardSquareMerchantResponse} from '@cash-web/protos/squareup/cash/local/v1/seller/cash_app_local_seller_service.pb'


export const onboardSquareMerchant = (request: OnboardSquareMerchantRequest, options?: CashRequestOptions) => post<OnboardSquareMerchantRequest, OnboardSquareMerchantResponse>("/2.0/cash/onboard-square-merchant", request, {...options, rejectOnError: true })